<template>
  <div class="flex flex-col">
    <p
      class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6">
      Occupation Details</p>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
      <ComboBoxControl label="Occupation/Rank" fieldId="occupation" v-model="form.occupation" :required="true" :options="occupationOptions" />
      <TextControl ref="employer_name" label="Employer/Business Name" fieldId="employer_name" :required="true" v-model="form.employer_name" />
      <ComboBoxControl label="Nature of Work/Industry" fieldId="nature_of_work" v-model="form.nature_of_work" :required="true" :options="natureOfWorkOptions" />
      <TextControl ref="office_contact_number" label="Office Contact Number" fieldId="office_contact_number" is_phone :required="false" v-model="form.office_contact_number" :maxLength="10"/>
      <TextControl ref="office_address" label="Office/Business Address" fieldId="office_address" :required="true" v-model="form.office_address" />
    </div>
    

    <p
      class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">
      Other Information</p>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Purpose of the Account" fieldId="purpose_of_account" v-model="form.purpose_of_account" :required="true" :options="purposeOptions"/>
        <TextControl ref="fsourceoffund" label="Source of Funds" fieldId="fsourceoffund" :required="true" v-model="form.fsourceoffund" :disabled="false"/>
        <TextControl ref="amount_of_initial" label="Amount of Initial Deposit" fieldId="amount_of_initial" :required="true" v-model="form.amount_of_initial" :disabled="false" is_money/>
        <TextControl ref="mailing_address" label="Mailing Address" fieldId="mailing_address" :required="false" v-model="form.mailing_address" :disabled="false"/>
        <ComboBoxControl label="Source of Wealth" fieldId="source_of_wealth" v-model="form.source_of_wealth" :required="true" :options="sourceOptions"/>
        <TextControl ref="monthly_expected" label="Monthly Expected Credit (Max Amount in PHP)" fieldId="monthly_expected" is_money :required="true" v-model="form.monthly_expected" :disabled="false"/>
      </div>


    <p
      class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">
      Additional Information for Clients with Allowance as Source of Funds or Remittance as Purpose of the Account</p>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <TextControl ref="rel_sender" label="Relationship with the Sender" fieldId="rel_sender" :required="false" v-model="form.rel_sender" :disabled="false" />
        <TextControl ref="country_wealth" label="Country where the Wealth is coming from" fieldId="country_wealth" :required="false" v-model="form.country_wealth" :disabled="false" />
        <TextControl ref="occupation_sender" label="Occupation/Work of the Sender" fieldId="occupation_sender" :required="false" v-model="form.occupation_sender" :disabled="false" />
        <TextControl ref="nature_work_sender" label="Nature of Work/Industry" fieldId="nature_work_sender" :required="false" v-model="form.nature_work_sender" :disabled="false"/>
        <TextControl ref="purpose_allowance" label="Purpose of Allowance/Remittance" fieldId="purpose_allowance" :required="false" v-model="form.purpose_allowance" :disabled="false"/>
        <ComboBoxControl label="Account with Beneficial Owner" fieldId="accnt_beneficial" v-model="form.accnt_beneficial" :required="false" :options="yesNoOptions"/>
      </div>

    <p
      class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">
      Others</p>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Enabled E-Banking" fieldId="banking" v-model="form.banking" :required="true" :options="yesNoOptions"/>
        <ComboBoxControl label="Avail Credit Card" fieldId="credit_card" v-model="form.credit_card" :required="true" :options="yesNoOptions"/>
    </div>

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">PSO</p>
    <ComboBoxControl label="Choose a PSO that will verify your enrollment" fieldId="branch_code" v-model="form.branch_code" :options="psoOptions" required/>
    
    <div class="mt-8 xl:mt-16 flex flex-row gap-2 lg:gap-4 w-full justify-end">
      <ButtonControl theme="bg-white border-2 border-theme-primary text-theme-primary" rounded button_text="Back"
        @click="$emit('back')" class="w-full lg:w-[20%]"/>
      <ButtonControl theme="bg-primary border-2 border-theme-primary text-white" rounded button_text="Submit"
        @click="confirm_modal = true" class="w-full lg:w-[20%]" :disabled="!isFormComplete"/>
    </div>

    <!-- Confirmation Modal -->
    <ModalControl v-show="confirm_modal" v-bind:display="confirm_modal" question z_value="z-50"
          @positiveClick="submit" @negativeClick="confirm_modal = false" :positiveButton="'Yes'"
          :negativeButton="'No'" :default_width="'max-w-xl'">
          <div class="w-full px-5 pb-4 flex flex-col text-xl justify-center text-center items-center">
              Are you sure you want to submit the form?
          </div>
      </ModalControl>


  </div>
</template>

<script>
import TextControl from '@/components/controls/TextControl.vue';
import ComboBoxControl from '@/components/controls/ComboBoxControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';

import User from '@/services/User';
import mixin from '@/mixin';

export default {
  name: 'v-tab-3',
  inject: ['setLoading'],
  mixins: [mixin],
  data() {
    return {
        validationErrors: {},
        confirm_modal: false,
        yesNoOptions: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' }
        ],
        form: {
          occupation: "",
          employer_name: "",
          nature_of_work: "",
          office_contact_number: "",
          office_address: "",

          purpose_of_account: "",
          fsourceoffund: "",
          amount_of_initial: "",
          mailing_address: "",
          source_of_wealth: "",
          monthly_expected: "",

          rel_sender: "",
          country_wealth: "",
          occupation_sender: "",
          nature_work_sender: "",
          purpose_allowance: "",
          accnt_beneficial: "",
          banking: "",
          credit_card: ""
        }
    };
  },
  components: {
    TextControl,
    ComboBoxControl,
    ButtonControl,
    ModalControl
  },
  mounted() {
    this.restoreFormFromStore();
    this.$store.commit('setFormDataRCBC', this.form);
  },
  computed: {
    isFormComplete() {
      return (
        this.form.occupation && 
        this.form.employer_name &&
        this.form.nature_of_work &&
        this.form.office_address &&

        this.form.purpose_of_account &&
        this.form.fsourceoffund &&
        this.form.amount_of_initial &&
        this.form.source_of_wealth &&
        this.form.monthly_expected &&

        this.form.banking &&
        this.form.credit_card &&
        this.form.branch_code
      );
    },
    occupationOptions() {
      const lookup = this.$store?.state?.lookup || {};
      const occupations = lookup.occupation || [];

      return occupations.map(o => ({
        label: o,
        value: o
      }));
    },
    psoOptions() {
      const pso = this.$store.state.pso;

      if (!Array.isArray(pso)) return [];

      return pso.map(p => ({
        label: p.name,
        value: p.code
      }));
    },
    natureOfWorkOptions() {
      const lookup = this.$store?.state?.lookup || {};
      const work = lookup.nature_of_work_rcbc || [];

      return work.map(o => ({
        label: o,
        value: o
      }));
    },
    purposeOptions() {
      const lookup = this.$store?.state?.lookup || {};
      const purpose = lookup.purpose_of_the_account || [];

      return purpose.map(p => ({
        label: p,
        value: p
      }));
    },
    sourceOptions() {
      const lookup = this.$store?.state?.lookup || {};
      const source = lookup.source_of_wealth || [];

      return source.map(s => ({
        label: s,
        value: s
      }));
    },
  },
  watch: {
    form: {
      handler(newForm) {
        this.$store.commit('setFormDataRCBC', newForm);
      },
      deep: true
    },
    email() {
      const inputEl = this.$refs.email?.$el?.querySelector?.('input') || this.$refs.email?.querySelector?.('input');
      if (inputEl) {
        inputEl.classList.remove('error');
      }
    },
    phone() {
      const inputEl = this.$refs.phone?.$el?.querySelector?.('input') || this.$refs.phone?.querySelector?.('input');
      if (inputEl) {
        inputEl.classList.remove('error');
      }
    }
  },
  methods: {
    submit() {
      this.confirm_modal = false;
      this.setLoading(true);

      this.$emit('submit');
    },
    restoreFormFromStore() {
      const storeFormData = this.$store.state.formDataRCBC || {};

      Object.keys(this.form).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(storeFormData, key) && storeFormData[key] !== undefined && storeFormData[key] !== null) {
          this.form[key] = storeFormData[key];
        }
      });
    },
    submitForm() {
      this.confirm_modal = false;
      this.$emit('submit');
    },
  },
};
</script>

<style scoped>
.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.box {
  width: 4rem !important;
  height: 4rem !important;
  margin-right: 3rem !important; 
}
@media (max-width: 1000px) {
    .box {
      width: 2rem !important;
      height: 2rem !important;
      margin-right: 1rem !important;
      font-size:  5rem !important;
    }
    .agree {
      font-size: 1.7rem !important; 
    }
   

}

</style>